import LoginForm from "../Component/Account/Login";
import Layout from "../Layout/Layout";

const LoginPage = () => {
	return (
		<Layout>
			<LoginForm />
		</Layout>
	);
};

export default LoginPage;
